import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class CookieConsentConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getOneTrustIsEnabled(): boolean {
		return this.configService.get((x) => x.common.oneTrust.isEnabled, false);
	}

	getOneTrustCdnUrl(): string {
		return this.configService.get((x) => x.common.oneTrust.cdnUrl, "");
	}

	getOneTrustCookieDomain(): string {
		return this.configService.get((x) => x.common.oneTrust.cookieDomain, "");
	}

	getOneTrustDataDomainScript(): string {
		return this.configService.get((x) => x.common.oneTrust.dataDomainScript, "");
	}

	getOneTrustDataDocumentLanguage(): boolean {
		return this.configService.get((x) => x.common.oneTrust.dataDocumentLanguage, false);
	}

	getOneTrustDataLanguage(market: string): string | undefined {
		return this.configService.get((x) => x.common.oneTrust.dataLanguage, {})[market];
	}
}
